import React, { useEffect, useState } from 'react';
import { Navigate, Link, useLocation, Outlet, useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

export const superadminNavItems = [
  { 
    label: 'Dashboard', 
    path: '/superadmin/dashboard', 
    icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v4a2 2 0 01-2 2H6a2 2 0 01-2-2V6zm10 0a2 2 0 012-2h2a2 2 0 012 2v10a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v4a2 2 0 01-2 2H6a2 2 0 01-2-2v-4z" /></svg>
  },
  { 
    label: 'Schools/Tenants', 
    path: '/superadmin/tenants', 
    icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></svg>
  },
  { 
    label: 'Users', 
    path: '/superadmin/users', 
    icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" /></svg>
  },

  { 
    label: 'Analytics', 
    path: '/superadmin/analytics', 
    icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 01-2 2h2a2 2 0 012-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" /></svg>
  },

  { 
    label: 'Password Resets', 
    path: '/superadmin/support', 
    icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4v-3.252l7.512-7.512A6 6 0 1115 7h0z" /></svg>
  },

  { 
    label: 'System Settings', 
    path: '/superadmin/settings', 
    icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
  },

  { 
    label: 'Audit Logs', 
    path: '/superadmin/audit-logs', 
    icon: <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
  }
];

export const SuperadminLayout: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user: authUser } = useAuth();
  
  const token = localStorage.getItem('superadminToken');
  const userData = localStorage.getItem('superadminUser');
  
  const [sidebarExpanded, setSidebarExpanded] = useState(true);
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const user = authUser?.role === 'superadmin' ? authUser : userData ? JSON.parse(userData) : null;
  const isDashboard = location.pathname === '/superadmin/dashboard';

  const currentNav = superadminNavItems.find(item => location.pathname.startsWith(item.path)) || superadminNavItems[0];

  const handleLogout = () => {
    localStorage.removeItem('superadminToken');
    localStorage.removeItem('superadminUser');
    navigate('/login');
  };

  const initials = user ? `${user.first_name?.charAt(0) || ''}${user.last_name?.charAt(0) || ''}`.toUpperCase() : 'SA';

  const renderSidebarLinks = (onClickCallback?: () => void) => {
    return superadminNavItems.map((item) => {
      const active = location.pathname.startsWith(item.path);
      return (
        <Link
          key={item.label}
          to={item.path}
          onClick={onClickCallback}
          className={`flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200 text-nav ${
            active 
              ? 'bg-indigo-600 text-white font-semibold shadow-md' 
              : 'text-slate-600 hover:text-indigo-600 hover:bg-indigo-50'
          }`}
        >
          <span className="shrink-0">{item.icon}</span>
          <span className={`transition-opacity duration-200 ${!sidebarExpanded ? 'lg:hidden' : ''}`}>
            {item.label}
          </span>
        </Link>
      );
    });
  };

  return (
    <div className="flex flex-col h-screen w-screen overflow-hidden bg-slate-50 text-slate-900">
      
      <header className="sticky top-0 z-30 bg-white border-b border-slate-200 h-16 px-4 md:px-8 flex items-center justify-between shadow-sm shrink-0 w-full">
        <div className="flex items-center gap-3">
          <button 
            onClick={() => setMobileDrawerOpen(true)} 
            className="md:hidden p-2 rounded-lg text-slate-500 hover:text-slate-800 hover:bg-slate-100 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          <div className="flex items-center gap-3">
            <Link to="/superadmin/dashboard" className="flex items-center shrink-0 transition-transform hover:scale-105">
              <img src={process.env.PUBLIC_URL + '/logo.png'} alt="System Logo" className="h-10 w-auto max-w-[150px] rounded-lg bg-white p-1 object-contain shadow-sm border border-slate-200" />
            </Link>
            <div className="flex items-center gap-2 text-helper font-semibold text-slate-400">
              <Link to="/superadmin/dashboard" className="hidden sm:inline text-slate-700 font-bold text-lg hover:text-indigo-600 transition-colors">
                System Management
              </Link>
              <span className="hidden sm:inline text-slate-300 text-lg">/</span>
              <span className="text-slate-800 font-bold text-lg">{currentNav.label}</span>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <div className="text-right hidden sm:block">
            <p className="font-bold text-helper text-slate-800 leading-tight">{user ? `${user.first_name} ${user.last_name}` : 'System Admin'}</p>
            <span className="text-[9px] text-indigo-600 font-bold uppercase tracking-wider leading-none">Global Owner</span>
          </div>
          <div className="w-8 h-8 rounded-full bg-indigo-600 text-white flex items-center justify-center font-bold text-helper border-2 border-white shadow-md">
            {initials}
          </div>
        </div>
      </header>

      <div className="flex flex-1 overflow-hidden">
        {/* Desktop Sidebar Navigation */}
        {!isDashboard && (
          <aside className={`hidden md:flex flex-col bg-white text-slate-800 shrink-0 shadow-lg border-r border-slate-200 transition-all duration-200 z-20 ${
            sidebarExpanded ? 'w-64' : 'w-20'
          }`}>

            <nav className="flex-1 overflow-y-auto px-3 py-6 space-y-1.5 sidebar-scrollbar">
              {renderSidebarLinks()}
            </nav>

            <div className="p-3 border-t border-slate-200 space-y-1">
              <button 
                onClick={() => setSidebarExpanded(!sidebarExpanded)} 
                className="w-full flex items-center justify-center py-2.5 rounded-lg text-slate-500 hover:text-indigo-600 hover:bg-indigo-50 transition-all text-helper font-medium gap-2"
              >
                <svg className={`w-4 h-4 transition-transform duration-200 ${sidebarExpanded ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 5l7 7-7 7M5 5l7 7-7 7" />
                </svg>
                <span className={sidebarExpanded ? 'inline' : 'hidden'}>Collapse Sidebar</span>
              </button>
              
              <button 
                onClick={handleLogout} 
                className="w-full flex items-center py-2.5 px-3 rounded-lg text-rose-400 hover:text-rose-300 hover:bg-rose-500/10 transition-all text-helper font-medium gap-2"
              >
                <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
                <span className={sidebarExpanded ? 'inline' : 'hidden'}>Sign Out</span>
              </button>
            </div>
          </aside>
        )}

        {/* Mobile Drawer Overlay */}
        {mobileDrawerOpen && (
          <div className="fixed inset-0 z-40 md:hidden bg-slate-900/60 backdrop-blur-sm transition-opacity" onClick={() => setMobileDrawerOpen(false)}>
            <aside className="w-64 max-w-[80vw] h-full bg-white text-slate-800 flex flex-col justify-between py-6 shadow-2xl animate-slide-in" onClick={e => e.stopPropagation()}>
              <div>
                <div className="flex items-center gap-3 px-5 mb-6 border-b border-slate-200 pb-5">
                  <img src={process.env.PUBLIC_URL + '/logo.png'} alt="System Logo" className="w-9 h-9 rounded-lg bg-white p-0.5 object-cover" />
                  <div>
                    <h2 className="font-bold text-xs text-slate-800 leading-tight">Master Console</h2>
                    <span className="text-[9px] text-indigo-500 font-bold uppercase tracking-wider">T-file Superadmin</span>
                  </div>
                </div>
                <nav className="flex flex-col gap-1.5 px-3">
                  {renderSidebarLinks(() => setMobileDrawerOpen(false))}
                </nav>
              </div>
              <div className="px-5 border-t border-slate-200 pt-5">
                <button 
                  onClick={() => { setMobileDrawerOpen(false); handleLogout(); }} 
                  className="w-full flex items-center gap-3 py-3 text-rose-400 font-semibold text-helper"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                  </svg>
                  <span>Sign Out</span>
                </button>
              </div>
            </aside>
          </div>
        )}

        {/* Main Workspace Container */}
        <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
          <div className="flex-1 min-h-0">
            <main className="h-full overflow-y-auto p-4 md:p-8 bg-slate-50">
              <Outlet />
            </main>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuperadminLayout;
